import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue"
import {
  ClientDetailFragmentFragment,
  CompanySizeRangeEnum,
  OwnershipStructureEnum,
  ClientEventsEnum,
  TransitionStateMutation,
  TransitionStateMutationMutation,
  TransitionStateMutationMutationVariables,
} from "@/gql"
import Icon from "@/components/widgets/icons/Icon.vue"
import { resolveUrl } from "@/hooks/useUrl"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { CompanySizeRange, OwnershipStructure, ClientEventMessages } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
  client: {
    type: Object as PropType<ClientDetailFragmentFragment | null>,
  },
  onUpdated: {
    type: Function as PropType<() => void>,
    default: () => undefined,
  },
},
  setup(__props) {

const props = __props

const { addSuccess } = useNotification()
const showAcceptDialog = ref(false)
const showRejectDialog = ref(false)
const showRejectModal = ref(false)

const rejectionReason = ref("")
const loading = ref(false)
const { mutate } = useMutation()

const getOwnershipStructure = (value: OwnershipStructureEnum) => {
  return OwnershipStructure.find((range) => range.value === value)?.text
}

const getCompanySizeRange = (value: CompanySizeRangeEnum) => {
  return CompanySizeRange.find((range) => range.value === value)?.text
}

async function transitionClientState(event: ClientEventsEnum, rejectionReason?: string) {
  loading.value = true

  const result = await mutate<
    TransitionStateMutationMutation,
    TransitionStateMutationMutationVariables
  >({
    mutation: TransitionStateMutation,
    variables: {
      clientId: props.client?.prn || "",
      event: event,
      rejectionReason: rejectionReason || undefined,
    },
    done: () => {
      loading.value = false
      closeModals()
    },
    handlePayloadErrors: true,
  })

  if (result?.data?.transitionClientState && !result?.data?.transitionClientState.error) {
    const verb = ClientEventMessages[event]
    addSuccess(`Client ${verb} successfully`)
    props.onUpdated()
  }
}

function closeModals() {
  showRejectDialog.value = false
  showRejectModal.value = false
  showAcceptDialog.value = false
  rejectionReason.value = ""
}



return { __sfc: true,addSuccess, showAcceptDialog, showRejectDialog, showRejectModal, rejectionReason, loading, mutate, getOwnershipStructure, getCompanySizeRange, transitionClientState, closeModals, props, ClientEventsEnum, Icon, resolveUrl }
}

})